import Storage from 'services/storage'

const storage = new Storage('invitees')

export const retrieveTimeNotation = () => storage.get('time_notation')

export const storeTimeNotation = (notation) => storage.set('time_notation', notation)
